/* ============================================================================
   TREKANO PARTS PDP — single behaviour owner. Loaded (defer) only on parts
   product pages from snippets/trk-parts-tabs.liquid.

   Contains: 1) add-on configurator (radio groups, selected cards, sticky-bar
   sync, ATC hijack scoped to the main form) · 2) sticky bar (show-on-scroll +
   footer dock). Desktop gallery is a plain CSS stack — no carousel JS.

   NO Liquid in this file — dynamic values come from data attributes:
   [data-t-configurator] carries data-base-price, data-props-key, data-product-title.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + dollars + '.' + parts[1];
  }

  /* ── 1. ADD-ON CONFIGURATOR ─────────────────────────────────────────── */
  function initConfigurator(root) {
    if (root.dataset.tConfiguratorInit === 'true') return;
    root.dataset.tConfiguratorInit = 'true';

    var basePrice = parseInt(root.dataset.basePrice || 0, 10);
    var baseEl = root.querySelector('[data-t-base-value]');
    var addonsEl = root.querySelector('[data-t-addons-value]');
    var totalEl = root.querySelector('[data-t-total-value]');
    var summaryEl = root.querySelector('.t-configurator__summary');

    function getMainQuantity() {
      var qty = document.querySelector('input[name="quantity"]');
      return qty ? parseInt(qty.value, 10) || 1 : 1;
    }
    /* The FIRST /cart/add form on a PDP is Shopify's hidden payment-terms form (no
       buttons); quick-buy cards add more. Main form = first non-quick-buy form with a
       buy button. The in-page button is visually hidden but MUST stay in the DOM. */
    function getMainForm() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if ((forms[i].className || '').indexOf('quick') === -1 && forms[i].querySelector('[name="add"], button[type="submit"]')) return forms[i];
      }
      return forms[0] || null;
    }
    function getMainVariantId() {
      var mf = getMainForm();
      var v = mf && mf.querySelector('input[name="id"], select[name="id"]');
      return v ? v.value : null;
    }

    /* Bundled components — the parallel pipe-delimited arrays written by
       snippets/trk-addon-extras.liquid from configurator.included_items/_qty/_max.
       `inc` of each is already inside the bundle price; anything above that is
       charged at the component's own price and goes to the cart as its own line.
       The chosen quantity lives on the radio (data-extra-sel) so it survives the
       guarded re-render and resets naturally when the option changes. */
    function extrasOf(radio) {
      if (!radio || !radio.value) return [];
      var titles = (radio.dataset.extraTitles || '').split('|').filter(Boolean);
      if (!titles.length) return [];
      var urls = (radio.dataset.extraUrls || '').split('|');
      var imgs = (radio.dataset.extraImgs || '').split('|');
      var prices = (radio.dataset.extraPrices || '').split('|');
      var vids = (radio.dataset.extraVids || '').split('|');
      var cents = (radio.dataset.extraCents || '').split('|');
      var incs = (radio.dataset.extraQtys || '').split('|');
      var maxes = (radio.dataset.extraMaxes || '').split('|');
      var sel = (radio.dataset.extraSel || '').split('|');
      return titles.map(function (title, i) {
        var inc = parseInt(incs[i], 10) || 1;
        var max = parseInt(maxes[i], 10) || inc;
        if (max < inc) max = inc;
        var qty = parseInt(sel[i], 10) || inc;
        if (qty < inc) qty = inc;
        if (qty > max) qty = max;
        return {
          index: i, title: title, url: urls[i] || '', img: imgs[i] || '', price: prices[i] || '',
          vid: parseInt(vids[i], 10) || 0, cents: parseInt(cents[i], 10) || 0,
          inc: inc, max: max, qty: qty
        };
      });
    }
    function extrasSurcharge(radio) {
      return extrasOf(radio).reduce(function (sum, x) { return sum + (x.qty - x.inc) * x.cents; }, 0);
    }
    function setExtraQty(radio, index, qty) {
      radio.dataset.extraSel = extrasOf(radio).map(function (x, i) {
        return i === index ? qty : x.qty;
      }).join('|');
    }

    function getSelectedAddons() {
      var items = [];
      document.querySelectorAll('[data-t-configurator]').forEach(function (cfg) {
        var propsKey = cfg.dataset.propsKey || '_Add-on for';
        var properties = {};
        properties[propsKey] = cfg.dataset.productTitle || '';
        cfg.querySelectorAll('[data-t-addon]').forEach(function (sel) {
          if (sel.value) items.push({ id: parseInt(sel.value, 10), quantity: 1, properties: properties });
        });
        cfg.querySelectorAll('[data-t-addon-radio]:checked').forEach(function (r) {
          if (!r.value) return;
          var props = properties;
          var row = r.closest('[data-t-addon-group]');
          var w = row && row.querySelector('[data-t-lightslots][data-for-value="' + r.value + '"]');
          if (w) {
            var seq = [];
            w.querySelectorAll('.t-lightslots__dot').forEach(function (d) { seq.push(d.dataset.color === 'amber' ? 'Amber' : 'Clear'); });
            props = Object.assign({}, properties);
            props['Light layout (left to right)'] = seq.join(', ');
          }
          /* Install scope, per line: the customer may hand over some of the build and
             fit the rest themselves (tick-list in the install block). */
          if (window.__trkInstallState && window.__trkInstallState.wanted) {
            if (props === properties) props = Object.assign({}, properties);
            props['Install'] = window.__trkInstallState.includesInput(r) ? 'Yes' : 'No';
          }
          items.push({ id: parseInt(r.value, 10), quantity: 1, properties: props });
          /* Components taken above the number the package includes = own cart line. */
          extrasOf(r).forEach(function (x) {
            var over = x.qty - x.inc;
            if (over > 0 && x.vid) items.push({ id: x.vid, quantity: over, properties: properties });
          });
        });
      });
      return items;
    }

    /* Selection card for a multi-select group: one row per ticked kit, same row
       language as everywhere else (photo · name · price). The single-selection head
       row is unused here, so it stays hidden. */
    function renderMultiCard(card, checkedAll) {
      var mainRow = card.querySelector('.t-addons__sel-main');
      if (mainRow && !mainRow.hidden) mainRow.hidden = true;
      var listEl = card.querySelector('[data-t-sel-extras]');
      if (!listEl) return;
      if (!checkedAll.length) {
        if (!card.hidden) card.hidden = true;
        if (listEl.dataset.sig !== '') { listEl.dataset.sig = ''; while (listEl.firstChild) listEl.removeChild(listEl.firstChild); }
        return;
      }
      var sig = checkedAll.map(function (c) { return c.value; }).join(',');
      if (listEl.dataset.sig !== sig) {
        listEl.dataset.sig = sig;
        while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
        checkedAll.forEach(function (c) {
          var line = document.createElement('div');
          line.className = 't-addons__sel-extra';
          var src = c.dataset.img || '';
          if (src) {
            var im = document.createElement('img');
            im.className = 't-addons__sel-extra-img';
            im.src = src; im.alt = ''; im.width = 72; im.height = 72;
            line.appendChild(im);
          }
          var info = document.createElement('span');
          info.className = 't-addons__sel-extra-info';
          var nameNode = document.createElement(c.dataset.url ? 'a' : 'span');
          nameNode.className = 't-addons__sel-extra-name';
          nameNode.textContent = c.dataset.name || '';
          if (c.dataset.url) { nameNode.href = c.dataset.url; nameNode.target = '_blank'; nameNode.rel = 'noopener'; }
          info.appendChild(nameNode);
          line.appendChild(info);
          var pr = document.createElement('span');
          pr.className = 't-addons__sel-extra-price is-charged';
          pr.textContent = '+' + formatMoney(parseInt(c.dataset.price || 0, 10));
          line.appendChild(pr);
          listEl.appendChild(line);
        });
      }
      if (card.hidden) card.hidden = false;
    }

    function update() {
      var qty = getMainQuantity();
      var addonsTotal = 0;
      var addonNames = [];
      root.querySelectorAll('[data-t-addon]').forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (sel.value && opt) { addonsTotal += parseInt(opt.dataset.price || 0, 10); addonNames.push(opt.textContent.trim().replace(/\s*\(\+.*$/, '')); }
      });
      root.querySelectorAll('[data-t-addon-radio]:checked').forEach(function (r) {
        if (r.value) { addonsTotal += parseInt(r.dataset.price || 0, 10) + extrasSurcharge(r); var lb = r.closest('label'); var nmSrc = r.dataset.name || (lb ? lb.textContent : ''); if (nmSrc) addonNames.push(nmSrc.trim().replace(/\s*\(\+.*$/, '')); }
      });
      var baseTotal = basePrice * qty;
      if (baseEl) baseEl.textContent = formatMoney(baseTotal);
      if (addonsEl) addonsEl.textContent = formatMoney(addonsTotal);
      if (totalEl) totalEl.textContent = formatMoney(baseTotal + addonsTotal);
      if (summaryEl) summaryEl.classList.toggle('is-active', addonsTotal > 0);

      /* Sticky bar sync — guarded writes only (the rerender observer re-runs this;
         writing identical values prevents mutation loops). */
      var barTotal = document.querySelector('[data-trk-bar-total]');
      if (barTotal) {
        var txt = formatMoney(baseTotal + addonsTotal);
        if (barTotal.textContent.trim() !== txt) barTotal.textContent = txt;
      }
      /* Bar button carries the live total on desktop ("Add to cart — $X"). */
      var barBtn = document.querySelector('.product-sticky-form .product-form__add-button');
      if (barBtn && !barBtn.disabled && !barBtn.classList.contains('is-loading') && window.innerWidth >= 741) {
        var baseLabel = barBtn.getAttribute('data-button-content') || 'Add to cart';
        var desired = baseLabel + ' \u2014 ' + formatMoney(baseTotal + addonsTotal);
        if (barBtn.textContent.trim() !== desired) barBtn.textContent = desired;
      }
      var barAddons = document.querySelector('[data-trk-bar-addons]');
      if (barAddons) {
        var t = addonNames.length ? '+ ' + addonNames.join(' · ') : '';
        if (barAddons.textContent !== t) barAddons.textContent = t;
        if (barAddons.hidden !== !addonNames.length) barAddons.hidden = !addonNames.length;
      }

      /* Selected-state cards above each group's buttons. */
      root.querySelectorAll('[data-t-addon-group]').forEach(function (row) {
        var card = row.querySelector('[data-t-group-sel]');
        if (!card) return;
        var img = card.querySelector('.t-addons__sel-img');
        var nameEl = card.querySelector('.t-addons__sel-name');
        var priceEl = card.querySelector('.t-addons__sel-price');
        var extrasEl = card.querySelector('[data-t-sel-extras]');
        /* Multi-select groups (side + rear lights \u2014 a customer can mount several kits)
           are tick-lists: every ticked item gets its own row in the card and its own
           cart line. Single-choice groups keep the one-selection card below. */
        var isMulti = row.hasAttribute('data-t-multi');
        var checkedAll = Array.prototype.filter.call(
          row.querySelectorAll('[data-t-addon-radio]:checked'), function (c) { return !!c.value; });
        var checked = checkedAll[0] || row.querySelector('[data-t-addon-radio]:checked');
        var active = !!(checked && checked.value);
        var st = row.querySelector('[data-t-acc-state]');
        if (st) {
          var stTxt = 'None';
          if (active && isMulti) {
            var mTotal = 0;
            stTxt = checkedAll.map(function (c) {
              mTotal += parseInt(c.dataset.price || 0, 10) + extrasSurcharge(c);
              return c.dataset.name || '';
            }).join(' + ') + ' \u00b7 +' + formatMoney(mTotal);
          } else if (active) {
            var lb2 = checked.closest('label');
            var nm = checked.dataset.name || (lb2 ? lb2.textContent.trim().replace(/\s+/g, ' ') : '');
            stTxt = nm + ' \u00b7 +' + formatMoney(parseInt(checked.dataset.price || 0, 10) + extrasSurcharge(checked));
          }
          if (st.textContent !== stTxt) st.textContent = stTxt;
          if (st.classList.contains('is-set') !== active) st.classList.toggle('is-set', active);
        }
        if (isMulti) {
          renderMultiCard(card, checkedAll);
          return;
        }
        row.querySelectorAll('[data-t-lightslots]').forEach(function (w) {
          var on = !!(checked && checked.value && String(checked.value) === w.dataset.forValue);
          if (w.hidden !== !on) w.hidden = !on;
        });
        if (active) {
          var nTxt = checked.dataset.name || '';
          var nUrl = checked.dataset.url || '';
          var xs = extrasOf(checked);
          var pTxt = '+' + formatMoney(parseInt(checked.dataset.price || 0, 10) + extrasSurcharge(checked));
          var parts = nTxt.split(' + ');
          /* When the components' prices ADD UP to the option price, they ARE the whole
             package (aircon combos) — the head row would just repeat the first one's
             photo and name, so it's dropped and the components stand on their own.
             When they're only part of it (LP6 package + its rock guards) the head row
             stays and the components sit under an "included" caption. */
          var optionCents = parseInt(checked.dataset.price || 0, 10);
          var componentsAreWhole = xs.length > 0 && xs.reduce(function (s, x) { return s + x.inc * x.cents; }, 0) === optionCents;
          var mainRow = card.querySelector('.t-addons__sel-main');
          if (mainRow && mainRow.hidden !== componentsAreWhole) mainRow.hidden = componentsAreWhole;
          /* With components itemised below, the head row carries the WHOLE bundle name —
             showing only the first part read as a duplicate of the component line. */
          var mainName = xs.length ? nTxt : parts[0];
          if (nameEl && nameEl.dataset.rendered !== mainName) {
            nameEl.dataset.rendered = mainName;
            nameEl.textContent = mainName;
          }
          if (extrasEl) {
            var sig = checked.value + '::' + (checked.dataset.extraTitles || '') + '::' + parts.slice(1).join(',') + '::' + componentsAreWhole;
            if (extrasEl.classList.contains('is-primary') !== componentsAreWhole) extrasEl.classList.toggle('is-primary', componentsAreWhole);
            if (extrasEl.dataset.sig !== sig) {
              extrasEl.dataset.sig = sig;
              while (extrasEl.firstChild) extrasEl.removeChild(extrasEl.firstChild);
              if (xs.length) {
                /* Real bundled products (configurator.included_items) — same photo size,
                   name treatment and columns as the head row, one box per component.
                   The caption only earns its place when there's a head row above it. */
                if (!componentsAreWhole) {
                  var cap = document.createElement('span');
                  cap.className = 't-addons__sel-extras-cap';
                  cap.textContent = 'Included in this package';
                  extrasEl.appendChild(cap);
                }
                xs.forEach(function (x) {
                  var line = document.createElement('div');
                  line.className = 't-addons__sel-extra';
                  line.setAttribute('data-t-extra', String(x.index));
                  if (x.img) {
                    var img2 = document.createElement('img');
                    img2.className = 't-addons__sel-extra-img';
                    img2.src = x.img; img2.alt = ''; img2.width = 72; img2.height = 72;
                    line.appendChild(img2);
                  }
                  var info = document.createElement('span');
                  info.className = 't-addons__sel-extra-info';
                  var nameNode = document.createElement(x.url ? 'a' : 'span');
                  nameNode.className = 't-addons__sel-extra-name';
                  nameNode.textContent = x.title;
                  if (x.url) { nameNode.href = x.url; nameNode.target = '_blank'; nameNode.rel = 'noopener'; }
                  info.appendChild(nameNode);
                  var note = document.createElement('span');
                  note.className = 't-addons__sel-extra-note';
                  note.setAttribute('data-t-extra-note', '');
                  info.appendChild(note);
                  line.appendChild(info);
                  if (x.max > x.inc) {
                    var qtyWrap = document.createElement('span');
                    qtyWrap.className = 't-addons__sel-extra-qty';
                    ['-1', '1'].forEach(function (dir) {
                      if (dir === '1') {
                        var count = document.createElement('span');
                        count.className = 't-addons__sel-extra-count';
                        count.setAttribute('data-t-extra-count', '');
                        qtyWrap.appendChild(count);
                      }
                      var b = document.createElement('button');
                      b.type = 'button';
                      b.className = 't-addons__sel-extra-step';
                      b.setAttribute('data-t-extra-step', dir);
                      b.textContent = dir === '1' ? '+' : '−';
                      b.setAttribute('aria-label', (dir === '1' ? 'More ' : 'Fewer ') + x.title);
                      qtyWrap.appendChild(b);
                    });
                    line.appendChild(qtyWrap);
                  }
                  var priceNode = document.createElement('span');
                  priceNode.className = 't-addons__sel-extra-price';
                  priceNode.setAttribute('data-t-extra-price', '');
                  line.appendChild(priceNode);
                  extrasEl.appendChild(line);
                });
              } else {
                /* Text-only fallback for bundles without a linkable product. */
                parts.slice(1).forEach(function (part) {
                  var row2 = document.createElement('div');
                  row2.className = 't-addons__sel-extra';
                  row2.textContent = '+ ' + part;
                  extrasEl.appendChild(row2);
                });
              }
            }
            /* Live state (count, stepper limits, surcharge) — rewritten every update. */
            xs.forEach(function (x) {
              var line = extrasEl.querySelector('[data-t-extra="' + x.index + '"]');
              if (!line) return;
              var count = line.querySelector('[data-t-extra-count]');
              if (count && count.textContent !== String(x.qty)) count.textContent = String(x.qty);
              line.querySelectorAll('[data-t-extra-step]').forEach(function (b) {
                var dis = parseInt(b.getAttribute('data-t-extra-step'), 10) < 0 ? x.qty <= x.inc : x.qty >= x.max;
                if (b.disabled !== dis) b.disabled = dis;
              });
              var over3 = x.qty - x.inc;
              var note2 = line.querySelector('[data-t-extra-note]');
              if (note2) {
                var nt = '';
                if (x.max > x.inc) {
                  nt = x.price + ' each · ' + x.inc + ' included in the package price';
                  if (over3 > 0) nt = x.price + ' each · ' + x.inc + ' included, ' + over3 + ' extra (+' + formatMoney(over3 * x.cents) + ')';
                }
                if (note2.textContent !== nt) note2.textContent = nt;
                if (note2.hidden !== !nt) note2.hidden = !nt;
              }
              var pe = line.querySelector('[data-t-extra-price]');
              if (pe) {
                /* Line total for the quantity showing — 2 × $49.95 = $99.90 — so the
                   component reads like a line on an invoice, not a unit price. */
                var over2 = x.qty - x.inc;
                var pt = x.max > x.inc ? formatMoney(x.qty * x.cents) : x.price;
                if (pe.textContent !== pt) pe.textContent = pt;
                var bold = over2 > 0 || componentsAreWhole;
                if (pe.classList.contains('is-charged') !== bold) pe.classList.toggle('is-charged', bold);
              }
            });
          }
          /* Name links to the add-on's own page (new tab keeps this config intact). */
          if (nameEl && nameEl.tagName === 'A' && nameEl.getAttribute('href') !== nUrl) {
            if (nUrl) nameEl.setAttribute('href', nUrl); else nameEl.removeAttribute('href');
          }
          if (priceEl && priceEl.textContent !== pTxt) priceEl.textContent = pTxt;
          var src = checked.dataset.img || '';
          if (img) {
            if (src) { if (img.getAttribute('src') !== src) img.setAttribute('src', src); if (img.hidden) img.hidden = false; }
            else if (!img.hidden) { img.hidden = true; }
          }
          if (card.hidden) card.hidden = false;
        } else if (!card.hidden) {
          card.hidden = true;
        }
      });
    }

    root.querySelectorAll('[data-t-addon]').forEach(function (s) { s.addEventListener('change', update); });
    root.querySelectorAll('[data-t-addon-radio]').forEach(function (r) { r.addEventListener('change', update); });
    /* Component quantity steppers — delegated, so they survive the card re-render. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-t-extra-step]');
      if (!btn) return;
      e.preventDefault();
      var line = btn.closest('[data-t-extra]');
      var grp = btn.closest('[data-t-addon-group]');
      var checked = grp && grp.querySelector('[data-t-addon-radio]:checked');
      if (!line || !checked) return;
      var idx = parseInt(line.getAttribute('data-t-extra'), 10) || 0;
      var x = extrasOf(checked)[idx];
      if (!x) return;
      var next = x.qty + (parseInt(btn.getAttribute('data-t-extra-step'), 10) || 0);
      if (next < x.inc) next = x.inc;
      if (next > x.max) next = x.max;
      if (next === x.qty) return;
      setExtraQty(checked, idx, next);
      update();
    });
    var qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) { qtyInput.addEventListener('change', update); qtyInput.addEventListener('input', update); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[name="plus"], [name="minus"], .quantity__button')) setTimeout(update, 50);
    });
    update();

    /* ATC hijack — capture-phase click on the MAIN form's buttons only (incl. the
       sticky bar's button, which references the form via its form attribute). */
    function hijackAddToCartButtons() {
      var mainForm = getMainForm();
      if (!mainForm) return;
      var buttons = Array.prototype.filter.call(
        document.querySelectorAll('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"], button[type="submit"][form]'),
        function (btn) {
          var f = btn.closest('form[action*="/cart/add"]');
          if (!f && btn.getAttribute('form')) f = document.getElementById(btn.getAttribute('form'));
          return !!(f && f === mainForm);
        });
      buttons.forEach(function (btn) {
        if (btn.dataset.tHijacked === 'true') return;
        btn.dataset.tHijacked = 'true';
        btn.addEventListener('click', function (e) {
          var addons = getSelectedAddons();
          if (addons.length === 0) return; /* no add-ons → native behaviour */
          e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
          var mainVariantId = getMainVariantId();
          var mainQty = getMainQuantity();
          if (!mainVariantId) return;
          var items = [{ id: parseInt(mainVariantId, 10), quantity: mainQty }].concat(addons);
          var originalText = btn.innerHTML;
          btn.setAttribute('disabled', 'disabled'); btn.classList.add('is-loading', 'loading');
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (response) {
              if (!response.ok) return response.text().then(function (err) { throw new Error('Cart add failed: ' + err); });
              return fetch('/cart.js');
            })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-link__bubble-num, .cart__count, [data-cart-counter]').forEach(function (el) { el.textContent = cart.item_count; });
              /* Focal contract: cart:refresh must be dispatched ON documentElement
                 (that's where its listener lives) — it re-renders the mini-cart section.
                 The drawer's `open` is a boolean property on the custom element, not a
                 method; setting it true shows the freshly rendered drawer. */
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
              setTimeout(function () {
                var drawer = document.getElementById('mini-cart') || document.querySelector('cart-drawer');
                var isOpen = drawer && (drawer.hasAttribute('open') || drawer.classList.contains('is-open'));
                if (drawer && !isOpen) { try { drawer.open = true; } catch (err) {} }
                setTimeout(function () {
                  var d2 = document.getElementById('mini-cart') || document.querySelector('cart-drawer');
                  var ok = d2 && (d2.hasAttribute('open') || d2.classList.contains('is-open'));
                  if (!ok) window.location.href = '/cart';
                }, 900);
              }, 400);
              btn.removeAttribute('disabled'); btn.classList.remove('is-loading', 'loading'); btn.innerHTML = originalText;
            })
            .catch(function (err) {
              console.error('[Trekano configurator]', err);
              alert('Sorry, something went wrong adding to cart. Please try again or contact us.');
              btn.removeAttribute('disabled'); btn.classList.remove('is-loading', 'loading'); btn.innerHTML = originalText;
            });
        }, true);
      });
    }
    hijackAddToCartButtons();
    var updateQueued = false;
    var observer = new MutationObserver(function () {
      /* Focal's product-rerender REPLACES the configurator markup: this closure's root
         goes stale, so retire the observer — the boot-level observer re-inits the new
         root (fresh listeners), which is what keeps selected cards alive post-rerender. */
      if (!root.isConnected) { observer.disconnect(); return; }
      hijackAddToCartButtons();
      if (!updateQueued) {
        updateQueued = true;
        requestAnimationFrame(function () { updateQueued = false; update(); });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ── 4. STICKY BAR: always visible + footer dock ────────────────────── */
  function initBar() {
    if (window.__trkBarDock) return; window.__trkBarDock = true;
    /* The bar is the single checkout point — Focal's component toggles a `hidden`
       attribute (opacity/visibility/transform hide, layered !important) so we strip
       the attribute whenever it appears rather than fighting the cascade. */
    function show() {
      var bar = document.querySelector('.product-sticky-form');
      if (bar && bar.hasAttribute('hidden')) bar.removeAttribute('hidden');
    }
    show();
    new MutationObserver(show).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    /* Show-on-scroll + footer dock: the bar stays off until the shopper starts
       scrolling the page, then rides at the bottom and locks onto the footer's top
       edge when it arrives. */
    function update() {
      show();
      var bar = document.querySelector('.product-sticky-form');
      if (!bar) return;
      var started = window.scrollY > 80;
      if (bar.classList.contains('trk-bar-off') === started) bar.classList.toggle('trk-bar-off', !started);
      /* The PAGE footer only — a bare `footer` selector also matches the cart drawer's
         internal <footer>, which lifted the bar mid-page. */
      /* Desktop: size/position the bar to the right panel's footprint. */
      var info = document.querySelector('.product.trk-pdp .product__info');
      if (info && window.innerWidth >= 741) {
        var pr = info.getBoundingClientRect();
        bar.style.setProperty('--trk-bar-left', pr.left + 'px');
        bar.style.setProperty('--trk-bar-w', pr.width + 'px');
      } else {
        bar.style.removeProperty('--trk-bar-left');
        bar.style.removeProperty('--trk-bar-w');
      }
      var footer = document.querySelector('[id^="shopify-section"][id$="__footer"], #shopify-section-footer, footer.footer');
      if (!footer) return;
      var off = Math.max(0, Math.min(window.innerHeight, window.innerHeight - footer.getBoundingClientRect().top));
      bar.style.setProperty('--trk-bar-bottom', off + 'px');
    }
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ── 3. CONTENT ACCORDION — exclusive: opening one closes the others ── */
  function initAccordion() {
    if (window.__trkAccInit) return; window.__trkAccInit = true;
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.trk-acc > .trk-acc__item[open]')) return;
      d.parentElement.querySelectorAll(':scope > .trk-acc__item[open]').forEach(function (o) {
        if (o !== d) o.open = false;
      });
      /* Any item opens → snap it to the top (Dave 31/07): on desktop the accordion
         lives in the panel scrollbox, so scroll THAT; on mobile scroll the page.
         rAF lets the sibling-close reflow settle first so offsets are right. */
      requestAnimationFrame(function () {
        if (window.innerWidth >= 1000) {
          var panel = document.querySelector('.product.trk-pdp .product__info');
          if (panel && panel.contains(d)) panel.scrollTo({ top: Math.max(0, d.offsetTop - 8), behavior: 'smooth' });
        } else {
          d.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      /* Installation additionally scrolls the PAGE so the install video (bottom of the
         LEFT media stack) lines up beside the panel. Desktop split layout only. */
      if (d.hasAttribute('data-trk-acc-install') && window.innerWidth >= 1000) {
        var v = document.querySelector('.product__media .trk-media-video:last-of-type') || document.querySelector('.trk-media-video');
        if (v) v.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, true);
  }

  /* ── 4. VARIANT → IMAGE: selecting a variant scrolls the stack to its photo ── */
  function initVariantImageScroll() {
    if (window.__trkVarImg) return; window.__trkVarImg = true;
    var map = null;
    var loading = false;
    function loadMap() {
      if (map || loading) return;
      var pm = document.querySelector('product-media[product-handle]');
      if (!pm) return;
      loading = true;
      fetch('/products/' + pm.getAttribute('product-handle') + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          map = {};
          (p.variants || []).forEach(function (v) {
            if (v.featured_media && v.featured_media.id) map[v.id] = v.featured_media.id;
          });
        })
        .catch(function () { loading = false; });
    }
    loadMap();
    document.addEventListener('change', function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      loadMap();
      /* Wait a tick for Focal to write the new variant id into the form. */
      setTimeout(function () {
        if (!map) return;
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        if (!idInput) return;
        var mediaId = map[parseInt(idInput.value, 10)];
        if (!mediaId) return;
        var item = document.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');
        if (item) item.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    });
  }

  /* Sub-headings in accordion bodies are authored as a paragraph holding ONLY a
     <strong> (e.g. DETAILS, COMPATIBILITY). Tag those so CSS can set them in the
     heading font — a class beats pure CSS here because :only-child can't tell a
     standalone bold from a mid-sentence lead bold with trailing text. */
  function tagSubheads() {
    document.querySelectorAll('.trk-acc__body p > strong:first-child').forEach(function (s) {
      var p = s.parentElement;
      if (p.textContent.trim() === s.textContent.trim()) p.classList.add('trk-subhead');
    });
  }

  /* ── LIGHT SLOT PICKER — per-pod Clear/Amber circles on light packages ─ */
  function initLightSlots() {
    if (window.__trkLightSlots) return; window.__trkLightSlots = true;
    document.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('.t-lightslots__dot');
      if (!dot) return;
      dot.dataset.color = dot.dataset.color === 'clear' ? 'amber' : 'clear';
      var w = dot.closest('[data-t-lightslots]');
      if (!w) return;
      var amber = 0, total = 0;
      w.querySelectorAll('.t-lightslots__dot').forEach(function (d) { total++; if (d.dataset.color === 'amber') amber++; });
      var ro = w.querySelector('[data-t-lightslots-readout]');
      if (ro) ro.textContent = (total - amber) + '\u00d7 Clear \u00b7 ' + amber + '\u00d7 Amber';
    });
  }

  /* ── ADD-ON ACCORDION — one group open at a time ──────────────────── */
  function initAddonAccordion() {
    if (window.__trkAddonAcc) return; window.__trkAddonAcc = true;
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.t-addons__acc[open]')) return;
      var cfg = d.closest('[data-t-configurator]') || document;
      cfg.querySelectorAll('.t-addons__acc[open]').forEach(function (o) { if (o !== d) o.open = false; });
      /* …and the one that opened snaps to the top so its options are in full view
         (same behaviour as the content accordion). Desktop: the right column is its
         own scrollbox, so scroll THAT, never the page — measured off rects because
         these rows have no positioned offsetParent to trust. Mobile: scroll the page.
         rAF lets the sibling-close reflow settle first. */
      var panel = document.querySelector('.product.trk-pdp .product__info');
      /* Gate on the panel ACTUALLY being a scrollbox (desktop split layout), not on a
         width guess — on mobile it isn't one, so the page scrolls instead. */
      if (!(panel && panel.contains(d) && panel.scrollHeight > panel.clientHeight + 4)) {
        requestAnimationFrame(function () { d.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        return;
      }
      /* Direct scrollTop assignment, not scrollTo({behavior:'smooth'}): the sibling
         group closing reflows the panel mid-animation and a smooth scroll gets
         cancelled by it, which is why the panel used to sit still. Re-assert once the
         reflow (and any late-loading image above) has settled. */
      var snap = function () {
        var top = panel.scrollTop + d.getBoundingClientRect().top - panel.getBoundingClientRect().top - 8;
        if (Math.abs(top - panel.scrollTop) > 2) panel.scrollTop = Math.max(0, top);
      };
      requestAnimationFrame(function () { snap(); setTimeout(snap, 150); });
    }, true);
  }

  /* ── AWNING → LEFT SIDE LIGHTS CAP — an awning takes the driver-side rail, so that
     side is capped at 2 pods total while one is fitted. Side lights are a tick-list
     now, so this is a RUNNING TOTAL: anything that would push the left side past 2 is
     disabled, and if an awning is added after the lights, the last ones ticked drop
     off until the side is back under the cap. ── */
  var LEFT_POD_CAP = 2;
  function syncAwningCap(cfg) {
    var awningChecked = cfg.querySelector('[data-t-awning-radio]:checked');
    var awningOn = !!(awningChecked && awningChecked.value);
    var left = Array.prototype.slice.call(cfg.querySelectorAll('[data-t-side-radio="left"]'));
    if (!left.length) return;
    function pods(r) { return parseInt(r.dataset.count || '0', 10) || 0; }
    function total() {
      return left.reduce(function (s, r) { return s + (r.checked ? pods(r) : 0); }, 0);
    }
    if (awningOn) {
      /* Shed from the end of the list until the side fits under the cap. */
      for (var i = left.length - 1; i >= 0 && total() > LEFT_POD_CAP; i--) {
        if (left[i].checked) { left[i].checked = false; left[i].dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
    var used = total();
    left.forEach(function (r) {
      var blocked = awningOn && !r.checked && (used + pods(r)) > LEFT_POD_CAP;
      if (r.disabled !== blocked) r.disabled = blocked;
      var lbl = r.closest('label');
      if (lbl) lbl.classList.toggle('t-addons__btn--soldout', blocked);
    });
  }
  function initAwningCap() {
    if (window.__trkAwningCap) return; window.__trkAwningCap = true;
    document.querySelectorAll('[data-t-configurator]').forEach(function (cfg) { syncAwningCap(cfg); });
    /* Re-run on awning changes AND on left-side ticks, since the cap is now a total. */
    document.addEventListener('change', function (e) {
      if (!e.target.matches) return;
      if (!e.target.matches('[data-t-awning-radio], [data-t-side-radio="left"]')) return;
      var cfg = e.target.closest('[data-t-configurator]');
      if (cfg) syncAwningCap(cfg);
    });
  }

  /* ── INSTALL ESTIMATE — base rack hours (server-computed) + hours from every
     currently-selected add-on (data-hours, set per Dave's rates: aircon/fan 4hrs
     flat, awning/roof rails 1.5hrs flat, front lights 3hrs first + 1hr/additional,
     side/rear lights 1hr per pod). Recomputes live as add-ons change. ── */
  /* Install SCOPE — the customer can hand the installer some of the build and fit the
     rest themselves, so the estimate and the cart flags follow the tick-list, not the
     whole order. Unticked keys live here (variant id, or 'base' for the product). */
  var installSkip = Object.create(null);
  /* Surcharge from bundled components taken above the included count (see extrasOf in
     the configurator) — recomputed here so the scope list can price a line. */
  function extrasSurchargeOf(r) {
    var cents = (r.dataset.extraCents || '').split('|');
    var incs = (r.dataset.extraQtys || '').split('|');
    var sel = (r.dataset.extraSel || '').split('|');
    return (r.dataset.extraTitles || '').split('|').filter(Boolean).reduce(function (s, t2, i) {
      var inc = parseInt(incs[i], 10) || 1;
      var q = parseInt(sel[i], 10) || inc;
      return s + Math.max(0, q - inc) * (parseInt(cents[i], 10) || 0);
    }, 0);
  }
  /* Keyed by input, not variant — left and right side lights share product ids, so a
     bare variant id would tie the two sides' rows together. */
  function installKey(input) { return (input.name || '') + '|' + input.value; }
  function installScopeItems() {
    var root = document.querySelector('[data-t-install]');
    if (!root) return [];
    var cfg = document.querySelector('[data-t-configurator]');
    var items = [{
      key: 'base',
      name: root.dataset.baseTitle || 'This item',
      hours: parseFloat(root.dataset.baseHours || '0'),
      cents: cfg ? parseInt(cfg.dataset.basePrice || '0', 10) : 0
    }];
    document.querySelectorAll('[data-t-addon-radio]:checked').forEach(function (r) {
      if (!r.value) return;
      /* Same kit can be picked on both sides — qualify it with its group so the two
         "2× S2 Pro" lines are tellable apart. */
      var nm = r.dataset.name || r.dataset.addonLabel || 'Add-on';
      var grp = (r.dataset.addonLabel || '').replace(/^Add\s+/i, '');
      if (grp && nm.toLowerCase().indexOf(grp.toLowerCase()) === -1) nm += ' (' + grp + ')';
      items.push({
        key: installKey(r), name: nm,
        hours: parseFloat(r.dataset.hours || '0'),
        cents: parseInt(r.dataset.price || '0', 10) + extrasSurchargeOf(r)
      });
    });
    return items;
  }
  function installWanted() {
    var yes = document.querySelector('.trk-install__yes');
    return !!(yes && yes.checked);
  }
  function installIncludes(key) { return !installSkip[key]; }
  function renderInstallScope() {
    var root = document.querySelector('[data-t-install]');
    var wrap = root && root.querySelector('[data-t-install-scope]');
    var list = root && root.querySelector('[data-t-install-list]');
    if (!wrap || !list) return;
    var items = installScopeItems();
    var sig = items.map(function (i) { return i.key; }).join(',');
    if (list.dataset.sig !== sig) {
      list.dataset.sig = sig;
      while (list.firstChild) list.removeChild(list.firstChild);
      items.forEach(function (item) {
        var label = document.createElement('label');
        label.className = 'trk-install__item';
        var box = document.createElement('input');
        box.type = 'checkbox';
        box.checked = installIncludes(item.key);
        box.setAttribute('data-t-install-item', item.key);
        var name = document.createElement('span');
        name.className = 'trk-install__item-name';
        name.textContent = item.name;
        label.appendChild(box);
        label.appendChild(name);
        var meta = document.createElement('span');
        meta.className = 'trk-install__item-hours';
        var bits = [];
        if (item.cents > 0) bits.push(formatMoney(item.cents));
        bits.push(item.hours > 0 ? item.hours + (item.hours === 1 ? ' hr' : ' hrs') : 'hours TBC');
        meta.textContent = bits.join(' \u00b7 ');
        label.appendChild(meta);
        list.appendChild(label);
      });
    }
    if (wrap.hidden !== !installWanted()) wrap.hidden = !installWanted();
    /* What the customer is fitting themselves, as one readable cart property. */
    var form = document.querySelector('form.shopify-product-form');
    if (form) {
      var excluded = items.filter(function (i) { return !installIncludes(i.key); }).map(function (i) { return i.name; });
      var input = form.querySelector('input[name="properties[Fitting myself]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Fitting myself]';
        form.appendChild(input);
      }
      var val = installWanted() && excluded.length ? excluded.join(', ') : '';
      if (input.value !== val) input.value = val;
    }
  }
  function initInstallScope() {
    if (window.__trkInstallScope) return; window.__trkInstallScope = true;
    /* Published for the configurator's cart builder (different closure). */
    window.__trkInstallState = { includesInput: function (el) { return installIncludes(installKey(el)); }, get wanted() { return installWanted(); } };
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches) return;
      if (t.matches('[data-t-install-item]')) {
        var key = t.getAttribute('data-t-install-item');
        if (t.checked) delete installSkip[key]; else installSkip[key] = true;
        renderInstallScope();
        syncInstallHours();
        return;
      }
      if (t.matches('[data-t-addon-radio], .trk-install__yes, .trk-install__no')) {
        renderInstallScope();
      }
    });
    renderInstallScope();
  }

  function syncInstallHours() {
    var root = document.querySelector('[data-t-install]');
    if (!root) return;
    var rate = parseFloat(root.dataset.rate || '0');
    /* Only what's still ticked in the scope list is quoted. */
    var totalHours = installScopeItems().reduce(function (s, i) {
      return s + (installIncludes(i.key) ? i.hours : 0);
    }, 0);
    var cost = Math.ceil(totalHours * rate);
    var costEl = root.querySelector('[data-t-install-cost]');
    var estEl = root.querySelector('[data-t-install-estimate]');
    var tbcEl = root.querySelector('[data-t-install-tbc]');
    if (costEl) costEl.textContent = '$' + cost;
    if (estEl) estEl.hidden = totalHours <= 0;
    if (tbcEl) tbcEl.hidden = totalHours > 0;
  }
  function initInstallHours() {
    if (window.__trkInstallHours) return; window.__trkInstallHours = true;
    document.addEventListener('change', function (e) {
      if (!e.target.matches) return;
      if (!e.target.matches('[data-t-addon-radio], .trk-install__yes, .trk-install__no')) return;
      syncInstallHours();
    });
    syncInstallHours();
  }

  /* ── BOOT ───────────────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('[data-t-configurator]').forEach(initConfigurator);
    initBar();
    initAccordion();
    initVariantImageScroll();
    initLightSlots();
    initAddonAccordion();
    initAwningCap();
    initInstallHours();
    initInstallScope();
    tagSubheads();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  /* Focal's product-rerender REPLACES configurator markup on variant change; the old
     inline-script era re-ran itself with the markup, an external asset doesn't. This
     observer re-inits any fresh configurator root (dataset guard keeps it idempotent)
     so add-on listeners + selected cards survive rerenders. */
  new MutationObserver(function () {
    document.querySelectorAll('[data-t-configurator]:not([data-t-configurator-init="true"])').forEach(initConfigurator);
    tagSubheads();
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

